/* eslint-disable no-param-reassign,no-unused-vars */
import Vue from 'vue';
import i18n from '@/form-i18n';
import UiEventBus from '@/UiEventBus';
import dayjs from 'dayjs';
import {v4 as uuidv4} from 'uuid';
import formStatusColor from "@/formStatusColor";
import formIdHelper from "@/form-id-helper";

const HelperPlugin = {
  install(/* vue */) {
    Vue.mixin({
      computed: {
        $themeColor() {
          if (this.$store) {
            return this.$store.state?.theme ? this.$store.state.theme : 'primary';
          }

          if (formIdHelper.getThemeParameter()) {
            const th = formIdHelper.getThemeParameter();
            if (th === 'daghemmet') {
              return 'paivakoti'
            } else if (th === 'bss') {
              return 'koulu';
            } else if (th === 'kultur') {
              return 'kulttuuri';
            }
          }

          return "primary";
        }
      },
      methods: {
        $isValidEmail(mail) {
          if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
            return true;
          }
          return false;
        },
        $showSuccessNotification(message) {
          UiEventBus.$emit('showNotification', {
            color: 'success',
            message,
            showButton: false,
          });
        },
        $showWarningNotification(message) {
          UiEventBus.$emit('showNotification', {
            color: 'warning',
            message,
            showButton: false,
          });
        },
        $showErrorNotification(message) {
          const msg = message != null ? message : i18n.t('generic_error');
          UiEventBus.$emit('showNotification', {
            color: 'error',
            message: msg,
            showButton: false,
          });
        },
        /**
         *
         * @param {!error} err
         * @param {msg} [msg] message to show
         */
        $handleApiError(err, msg) {
          console.error(err);
          if (err.response != null && err.response.data && err.response.data.error_key != null) {
            this.$showErrorNotification(i18n.t(err.response.data.error_key));
          } else {
            this.$showErrorNotification(msg);
          }
        },
        $reloadApp() {
          location.reload();
        },
        $formatTimeStamp(date) {
          return dayjs(date).format('LLLL');
        },
        /*
        $formatDateNoTime(date) {
          return date ? dayjs(date).format('L') : '';
        },*/
        $formatDateNoTime(date) {
          return date ? dayjs(date).format('DD.MM.YYYY') : '';
        },
        /*$formatDateTime(date) {
          return date ? dayjs(date).format('DD.MM.YYYY HH:mm:ss') : ''
        },*/
        $formatDateTime(date) { // International version
          return date ? dayjs(date).format('L LT') : ''
        },
        $formatYear(date) {
          return date ? dayjs(date).format('YYYY') : '';
        },
        $formatWeekDay(date) {
          return date ? dayjs(date).format('dd').capitalize() : '';
        },
        $formatTimeNoDate(date) {
          if (date) {
            return dayjs(date).format('LT');
          }
        },
        $formatMonthAndYear(date) {
          if (date) {
            return dayjs(date).format('MMM YYYY')
          }
        },
        $formatMonthAndYearLong(date) {
          if (date) {
            return dayjs(date).format('MMMM YYYY')
          }
        },
        $humanizeDuration(duration, showSeconds = false) {
          if (duration.asHours() > 23) {
            return Math.floor(duration.asHours()) + 'h ' + duration.minutes() + 'min';
          }
          return duration.hours() + 'h ' + duration.minutes() + 'min ' + (showSeconds ? duration.seconds() + 's' : '');
        },
        $randomizeColorFromString(string, saturation = 75, lightness = 40) {
          let hash = 0;
          if (string?.length > 0) {
            for (let i = 0; i < string.length; i++) {
              hash = string.charCodeAt(i) + ((hash << 5) - hash);
              hash = hash & hash; // Convert to 32bit integer
            }
          }

          if (hash < 0) hash = hash * -1;

          let shortened = hash % 200;
          return `hsl(${shortened}, ${saturation}%, ${lightness}%)`;
        },
        $snakeCase(str) {
          return str?.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        },
        $confirm(type, title, message, options) {
          return this.$root.$confirm(title, message, { color: type, ...options });
        },
        $confirmDelete(title, message) {
          return this.$root.$confirm(title, message, {color: 'error', agree: this.$t('delete')});
        },
        $randomString() {
          return (Math.random() + 1).toString(36).substring(2);
        },
        $tidTextField(field) {
          return field?.replace(new RegExp('Tid$'), 'Text');
        },
        $uuid() {
          return uuidv4();
        },
        $formStatusColor: formStatusColor,
      },
    });
  },
};
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
Vue.use(HelperPlugin);

export default HelperPlugin;
